// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { Tooltip, Button, Modal } from "antd";
import { ButtonType } from "antd/lib/button";
import { TooltipPlacement } from "antd/lib/tooltip";
import i18n from "i18next";

export interface TableProps {
  icon?: React.ReactNode;
  tooltipTitle: string;
  buttonClassName?: string | null;
  modalTitle: string;
  modalBody: string;
  buttonType?: ButtonType | null;
  disabled?: boolean;
  children?: string;
  onConfirm?: () => void;
  placement?: TooltipPlacement;
  tooltipPlacement?: TooltipPlacement;
  iconButton?: boolean;
  footer?: React.ReactNode[];
}

const ModalButton: React.FunctionComponent<TableProps> = (
  props: TableProps
) => {
  const {
    modalTitle,
    modalBody,
    tooltipTitle,
    tooltipPlacement,
    icon,
    buttonType,
    buttonClassName,
    disabled,
    children,
    iconButton,
    footer
  } = props;

  const [visible, setVisible] = useState<boolean>(false);

  const innerButton = iconButton ? (
    <Tooltip
      title={tooltipTitle}
      mouseEnterDelay={0.2}
      placement={tooltipPlacement ? tooltipPlacement : "bottom"}
    >
      <Button
        disabled={disabled}
        type={buttonType !== null ? buttonType : "default"}
        icon={icon}
        size="large"
        className={!disabled && buttonClassName !== null ? buttonClassName : ""}
        onClick={() => setVisible(true)}
      >
        {children ? children : ""}
      </Button>
    </Tooltip>
  ) : (
    <Button
      disabled={disabled}
      type={buttonType !== null ? buttonType : "default"}
      className={!disabled && buttonClassName !== null ? buttonClassName : ""}
      onClick={() => setVisible(true)}
    >
      {icon} {children ? children : ""}
    </Button>
  );

  const footerCloseButton = [
    <Button key="close" onClick={() => setVisible(false)}>
      {i18n.t("global.close")}
    </Button>
  ];

  return (
    <>
      {innerButton}
      <Modal
        title={modalTitle}
        visible={visible}
        centered
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        footer={footer && [...footerCloseButton, ...footer]}
      >
        {modalBody}
      </Modal>
    </>
  );
};
ModalButton.defaultProps = {
  buttonClassName: null,
  buttonType: null,
  iconButton: true
};

export default ModalButton;
